import { Button, GenericDialog } from '@/common'
import { useTranslation } from 'react-i18next'

export default function DialogMaxInstallationsReached({
  isOpen,
  close,
  supportEmail
}: {
  isOpen: boolean
  close: () => void
  supportEmail: string
}) {
  const { t } = useTranslation()
  return (
    <GenericDialog
      size="md"
      title={t('installations:maxInstallationsReachedDialog.title')}
      isOpen={isOpen}
      close={close}
    >
      <div className="space-y-4">
        <p>
          {t('installations:maxInstallationsReachedDialog.body', {
            supportEmail
          })}
        </p>
        <div className="flex justify-end">
          <Button variant="neutral" onClick={close}>
            {t('common:actions.close')}
          </Button>
        </div>
      </div>
    </GenericDialog>
  )
}
